import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/reducers';

const ProtectedRoute = ({ element: Element, ...rest }: any) => {
    const { token } = useSelector((e: RootState) => ({ token: e.token }));

    if (token === '') {
        return <Navigate to="/login" replace />;
    }

    return <Element {...rest} />;
};

export default ProtectedRoute;
